import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn("h-4 w-4 animate-spin text-slate-400", className)} />;
}

export function CenteredSpinner({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-10 gap-2">
      <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
      {label && <p className="text-sm text-slate-500">{label}</p>}
    </div>
  );
}
